define('plugin/client-login/model/ClientPasswordModel',['require','lib/model/BaseModel','lib/validator/ValidatorEmail','lib/validator/ValidatorNotEmpty','lib/validator/ValidatorIsEqual'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var ValidatorIsEqual = require('lib/validator/ValidatorIsEqual');

    /**
     * Client change password model
     *
     * @class ClientPasswordModel
     */
    return BaseModel.extend({

        url: '/ext/client/change-password/',

        defaults: {
            ///email: '',
            hash: '',
            password: '',
            password_confirm: ''
        },

        initialize: function () {
            this.validators = {
                //'email': [new ValidatorNotEmpty(), new ValidatorEmail()],
                'password': [new ValidatorNotEmpty({
                    error: Locale.get('error_value_is_empty')
                })],
                'password_confirm': [new ValidatorNotEmpty({
                    error: Locale.get('error_value_is_empty')
                }), new ValidatorIsEqual({
                    value: _.bind(function () {
                        return this.get('password');
                    }, this),
                    error: Locale.get('Passwords do not match')
                })]
            };

            BaseModel.prototype.initialize.call(this);
        },


        setErrors: function (errors) {
            this.validationError = {};
            _.each(errors, function (item) {
                var field = item.field;
                if(field === 'global_form'){
                    field = 'global_error';
                }

                if (item.errors) {
                    this.validationError[field] = _.isArray(item.errors) ? item.errors.join('; ') : item.errors;
                } else if (item.error) {
                    this.validationError[field] = item.error;
                }

                if (item.child_errors) {
                    var childModel = this.get(item.field);
                    if (childModel && _.isObject(childModel) && childModel.setErrors) {
                        childModel.setErrors(item.child_errors);
                    }
                }
            }, this);

            this.trigger('invalid');
        },

    });

});
